<!--

    need to be shared component but not the part of the footer

    <div fxLayout="row" fxLayoutAlign="center center">
    <div fxHide.xs class="get-involved" fxFlex="70" fxLayout="row">
        <div fxFlex="50" class="cover get-involved-cover" fxHide.lt-md></div>
        <div fxFlex="50" class="content">
            <h3>Get Involved</h3>
            <span>
                Would you like to learn more about MARIS? Do you have data that you
                would like to share with other MARIS users? Get in touch to learn
                how you can contribute to global marine radioactivity science and
                research.
            </span>
        </div>
    </div>
</div>-->

<div fxFlex fxLayout="row" fxLayoutAlign="stretch center">
    <div
        fxFlex
        class="enquiry py-4"
        fxLayoutGap="20px"
        fxFlex.gt-sm="70"
        fxFlexOffset.gt-sm="15"
        fxFlexOffset.sm="35px"
        fxLayout.gt-sm="row"
        fxLayout="row wrap"
        fxLayoutAlign="start center"
        ngClass.xs="xs"
        [ngClass.sm]="'sm'"
        fxFlexOffset.xs="25px"
    >
        <span class="enq-icon">?</span>
        <h5>Please get in touch using the <a [routerLink]="['/get-involved']">Get Involved</a>  contact form, by email <a href="mailto:NAML-MARIS.Contact-Point@iaea.org">NAML-MARIS.Contact-Point@iaea.org</a> or by phone +377 97 97 72 72</h5>
    </div>
</div>

<div class="footer" fxLayout="row" fxLayoutAlign="stretch center">
    <div fxLayout="column" fxFlexOffset.gt-sm="15" fxFlexOffset.xs="25px" fxFlexOffset.sm="35px">
        <h6>International Atomic Energy Agency (IAEA)</h6>
        <div>Vienna International Centre, PO Box 100, A-1400 Vienna, Austria</div>
        <div>
            Telephone: (+431) 2600-0, Facsimile: (+431) 2600-7, E-mail:
            <a href="mailto:Official.Mail@iaea.org">Official Mail</a>
        </div>
        <div fxLayout="column">
            <a href="mailto:NAML-MARIS.Contact-Point@iaea.org">Contact MARIS Administrators</a>
            <a href="https://nucleus.iaea.org/Home/Disclaimer.html" target="_blank">Disclaimer</a>
        </div>
    </div>
    <div fxLayout="column" fxFlex="50" fxLayoutAlign="end end"></div>
</div>
<div class="copyright" fxLayout="row" fxFlex="100" fxLayoutAlign="center center" ngClass.xs="xs">Copyright © 2023 International Atomic Energy Agency (IAEA). All rights reserved.</div>
